var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('v-card',{staticClass:"bubble mt-3",staticStyle:{"background-color":"orange","color":"rgba(0,0,0,.87)"},attrs:{"outlined":""}},[_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(" "+_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }